import { appStateMock, href } from 'app/utils/test/constants';

export const AVATAR_SIZE = 52;
export const OPTIONS_SIZE = 50;

export const TEST_STATES = {
  preloadedState: {
    ...appStateMock,
    auth: {
      ...appStateMock.auth,
      services: {
        contributions: {
          _links: {
            countryCodesAlpha2DDL: href,
          },
        },
      },
    },
  },
};
